export default "__VITE_ASSET__DZgHjWLK__"